import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d5b00f50"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "shadow sm:rounded-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Re-Employment\n          ")
], -1));
const _hoisted_4 = { key: 0 };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("fieldset", null, [
    /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "N/A")
], -1));
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", { class: "text-base font-medium text-gray-900" }, "\n              Would you re-employ the employee in the future? *\n            ", -1));
const _hoisted_9 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_10 = { class: "mt-4 space-y-4" };
const _hoisted_11 = { class: "flex items-start" };
const _hoisted_12 = { class: "h-5 flex items-center" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "re_employ-yes",
        class: "font-medium text-gray-700"
    }, "Yes")
], -1));
const _hoisted_15 = { class: "flex items-start" };
const _hoisted_16 = { class: "h-5 flex items-center" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "re_employ-no",
        class: "font-medium text-gray-700"
    }, "No")
], -1));
const _hoisted_19 = {
    key: 0,
    class: "col-span-6"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "reason",
    class: "block text-sm font-medium text-gray-700"
}, "If no, please provide a reason why: *", -1));
const _hoisted_21 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_22 = ["disabled"];
const _hoisted_23 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_24 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_25 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                (_ctx.reasonResignation === 'Death in Service')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.reasonResignation !== 'Death in Service')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                        _createElementVNode("fieldset", null, [
                            _hoisted_8,
                            _createTextVNode(),
                            (_ctx.v$.formData.re_employ.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "\n              * " + _toDisplayString(_ctx.v$.formData.re_employ.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _withDirectives(_createElementVNode("input", {
                                            id: "radio-button-re_employ",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formData.re_employ) = $event)),
                                            value: "yes",
                                            name: "re_employ-yes",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                }]),
                                            disabled: _ctx.disableForm,
                                            onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.re_employ.$touch()))
                                        }, null, 42, _hoisted_13), [
                                            [_vModelRadio, _ctx.formData.re_employ]
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_14
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                            _withDirectives(_createElementVNode("input", {
                                                id: "radio-button-re_employ",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.re_employ) = $event)),
                                                value: "No",
                                                name: "re_employ-no",
                                                type: "radio",
                                                class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                        'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                    }]),
                                                disabled: _ctx.disableForm,
                                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.re_employ.$touch()))
                                            }, null, 42, _hoisted_17), [
                                                [_vModelRadio, _ctx.formData.re_employ]
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_18
                                    ])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.re_employ === 'No')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _hoisted_20,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_21, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "reason-for-not-re-employing",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.reason) = $event)),
                                        name: "reason",
                                        rows: "3",
                                        class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm,
                                                'error-border': _ctx.v$.formData.reason.$error,
                                                'border-red-500': _ctx.v$.formData.reason.$error,
                                            }]),
                                        disabled: _ctx.disableForm,
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.reason.$touch()))
                                    }, null, 42, _hoisted_22), [
                                        [_vModelText, _ctx.formData.reason]
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.reason.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "\n                * " + _toDisplayString(_ctx.v$.formData.reason.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createTextVNode(),
            (!_ctx.disableForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid && _ctx.reasonResignation !== 'Death in Service',
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_25)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
